import React, { MouseEvent, useState } from 'react';

interface ModalProps {
  children: string;
  ctaText?: string;
  handleCloseModal: (event?: MouseEvent) => any;
  hideCloseButton?: boolean;
}

const Modal: React.FC<ModalProps> = ({ children, ctaText, handleCloseModal, hideCloseButton }) => {
  return (
    <div className="tfm-modal-container">
      <div className="tfm-modal-content">
        <div className="tfm-modal-content__text" dangerouslySetInnerHTML={{ __html: children }}></div>

        {!hideCloseButton && (
          <button type="button" className="tfm fm-a-button-close" onClick={handleCloseModal}>
            {ctaText ?? 'Close'}
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;
